<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Archive Courses Data
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="scroll-y overflow" style="height: calc(100vh - 65px - 10px - 48px) !important;">
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <div class="filterSection">
        <v-text-field
          v-model="search"
          label="Search Courses"
          type="text"
          @change="applyCourseSearch"
          append-icon="fa-search"
          class="filter-user"
        ></v-text-field>
        <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </div>
        <v-expansion-panels accordion 
          v-model="panel"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Completed Course</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :options.sync="getCompletedCourses"
                  :server-items-length="serverItemsLength"
                  v-show="!loading"
                  :items="courses"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                  :footer-props="{
                  'items-per-page-options': [5,10,15]
                  }"
                >
                  <template v-slot:item.name="{ item }">
                    <div class="course-title-wrapper">
                      <span class="ml-2">{{item.name}}</span>
                      <v-tooltip v-if="item.is_membership" bottom >
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class='isMember-Title'></div>
                        </template>
                        <span>Membership Content</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
     
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button"  @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-2 add-course-button" @click="archiveCourseData" :disabled="courses.length == 0">Archive</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";

export default {
  name: "CompletedCourse",
  components: {
    
  },
  props: {
    id: {
      type: String,

    },
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "name" },
      ],
      courses: [],
      search: "",
      pagination: {},
      getCompletedCourses: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      successMessage: "Course(s) Archived Successfully",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      count:0,
      serverItemsLength:0,
      categories: [],
      selectedCategory: [],
      panel: [0,1],
    };
  },
  computed: {
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.getCompletedCourses, this.serverItemsLength);
    },
    selectedArray: function() {
      let selectedCourses = [];
      this.selected.map(x => {
        selectedCourses.push(x.id);
      });
      return selectedCourses;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    getCompletedCourses: {
      handler() {
        this.completedCourses();
      },
      deep: true
    },
  },
  mounted() {
    this.getAllCourseCategories();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    archiveCourseData() {
      this.loading = true;
      
      courseAPI
        .archiveUserCourses({
          id: this.selectedArray
        })
        .then((response) => {
          EventBus.$emit('ANSWERS_SUBMITTED', response);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    completedCourses() {
      this.loading = true;
      courseAPI.getCompletedCourses(this.params+this.searchParams, this.id).then(response => {
        this.loading = false;
        this.courses = response.data.data;
        this.serverItemsLength = response.data.meta.pagination.total;
      });
    },
    applyCourseSearch() {
      this.getCompletedCourses.page = 1;
      this.searchParams = '';
      
      this.searchParams = this.search && this.search.length > 0
      ? '&course_name=' + this.search : '';
      
      if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }

      this.completedCourses();
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.applyCourseSearch();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    selectAllToggle({ value, items }) {
      if (value) {
        // Only select non-archived items
        const nonArchivedItems = items.filter(item => !item.is_course_archived);

        // Replace the selected2 with only non-archived ones
        this.selected2 = [...this.selected2, ...nonArchivedItems.filter(
          newItem => !this.selected2.some(sel => sel.id === newItem.id)
        )];
      } else {
        // Deselect only the visible, non-archived items
        const idsToRemove = items
          .filter(item => !item.is_course_archived)
          .map(item => item.id);

        this.selected2 = this.selected2.filter(
          selected => !idsToRemove.includes(selected.id)
        );
      }
    },
  }
};
</script>
<style scoped>
.course-title-wrapper {
    display: flex;
    justify-content: left !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 1em;
}

.isMember-Title::after {
    content: "";
    width: 15px;
    height: 14px;
    margin: 4px 1px 0px 0px;
    background-image: url(/static/safeguarding-stars.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
}

.isMember-Title {
    background-color: #83c902;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
}
</style>